export default __webpack_public_path__ + "static/media/insert-row-above.dcf04e3b.svg";